import { FolkRadianceCascade } from '../folk-radiance-cascade';
FolkRadianceCascade.define();
export { FolkRadianceCascade };
//# sourceMappingURL=folk-radiance-cascade.js.map